/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Anthropic_DescriptionInputs */

const en_admin_settings_groups_anthropic_description = /** @type {(inputs: Admin_Settings_Groups_Anthropic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic Claude API`)
};

const zh_admin_settings_groups_anthropic_description = /** @type {(inputs: Admin_Settings_Groups_Anthropic_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anthropic Claude API`)
};

/**
* | output |
* | --- |
* | "Anthropic Claude API" |
*
* @param {Admin_Settings_Groups_Anthropic_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_anthropic_description = /** @type {((inputs?: Admin_Settings_Groups_Anthropic_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Anthropic_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_anthropic_description(inputs)
	return zh_admin_settings_groups_anthropic_description(inputs)
});
export { admin_settings_groups_anthropic_description as "admin.settings.groups.anthropic.description" }